<template>
  <div class="btn btn-list-function" @click="click">
    <i
      class="fa m-b-5"
      :class="isOn ? 'fa-toggle-on' : 'fa-toggle-off'"
      v-tooltip.right.hover="tooltip"
      aria-hidden="true"
    ></i>
  </div>
</template>

<script>
export default {
  name: 'MiniToggle',
  props: {
    isOn: {
      type: Boolean,
      default: false,
    },
    tooltip: {
      type: String,
      default: '',
    },
  },
  methods: {
    click() {
      this.$emit('click');
    },
  }
};
</script>
